import React from "react";
import AutocompleteField from "./AutocompleteField";
import SelectField from "./SelectField";

export default function CustomSelectFieldWithOptions({ availableOptions, restrictToAvailableOptions, ...props }) {
  const options = availableOptions.map(value => [value, value]);

  if (restrictToAvailableOptions) {
    return <SelectField {...props} options={options} />;
  }

  return <AutocompleteField {...props} options={options} />;
} 